/* eslint-disable prettier/prettier */
// import logoAcredit from '@root/images/acredit/logo.png';
import nomadLifeLogo from '@images/nomadlife/logo2.svg';
import beecreditLogo from '@root/images/beecredit/beecredit_white_background.png';
import credit365Logo from '@root/images/credit365/logo.svg';
import creditplusLogo from '@root/images/creditPlus/logo.svg';
import customLogo from '@root/images/custom/custom-logo.png';
import goodPayLogo from '@root/images/custom/goodpay.svg';
import eurasia36Logo from '@root/images/eurasia/logo.png';
import logoInstallment from '@root/images/installment/logo.svg';
import logoOneCredit from '@root/images/onecredit/200_60.png';
import logoTengebai from '@root/images/tengebai/tengebai.svg';
import { ContentData } from './types';

export const getCustomContentData = (): ContentData => ({
  header: {
    title: 'NewPay',
    icon: customLogo
  },
  main: {},
  footer: {
    email: 'info@newpay.kz',
    firmInfo:
      'ТОО "Нью Пей" БИН 221040018026. ТОО «Нью Пей» с учетной регистрацией в качестве платежной организации, присвоен ' +
      'регистрационный номер № 02-22-142 и записан в Реестр платежных организаций.' +
      '© 2024 ® Newpay. Все права защищены."'
  }
});

export const getNewPayContentData = (): ContentData => ({
  header: {
    title: 'NewPay',
    icon: customLogo
  },
  main: {},
  footer: {
    email: 'info@goodpay.kz',
    firmInfo:
      'ТОО "Нью Пей" БИН 221040018026. ТОО «Нью Пей» с учетной регистрацией в качестве платежной организации, присвоен ' +
      'регистрационный номер № 02-22-142 и записан в Реестр платежных организаций.' +
      '© 2024 ® Newpay. Все права защищены."'
  }
});

export const getNomadLifeContentData = (): ContentData => ({
  header: {
    title: 'Nomad Life',
    icon: nomadLifeLogo
  },
  main: {},
  footer: {
    email: 'info@goodpay.kz',
    firmInfo:
      'ТОО "Нью Пей" БИН 221040018026. ТОО «Нью Пей» с учетной регистрацией в качестве платежной организации, присвоен ' +
      'регистрационный номер № 02-22-142 и записан в Реестр платежных организаций.' +
      '© 2024 ® Newpay. Все права защищены."'
  }
});

export const getEurasia36ContentData = (): ContentData => ({
  header: {
    title: 'Eurasia36',
    icon: eurasia36Logo
  },
  main: {},
  footer: {
    email: 'info@goodpay.kz',
    firmInfo:
      'ТОО "Нью Пей" БИН 221040018026. ТОО «Нью Пей» с учетной регистрацией в качестве платежной организации, присвоен ' +
      'регистрационный номер № 02-22-142 и записан в Реестр платежных организаций.' +
      '© 2024 ® Newpay. Все права защищены."'
  }
});

export const getGoodPayContentData = (): ContentData => ({
  header: {
    title: 'GoodPay',
    icon: goodPayLogo
  },
  main: {},
  footer: {
    email: 'info@newpay.kz',
    firmInfo:
      'ТОО "Нью Пей" БИН 221040018026. ТОО «Нью Пей» с учетной регистрацией в качестве платежной организации, присвоен ' +
      'регистрационный номер № 02-22-142 и записан в Реестр платежных организаций.' +
      '© 2024 ® Newpay. Все права защищены."'
  }
});

export const getAcreditContentData = (): ContentData => ({
  header: {
    title: 'ACredit',
    icon: customLogo
  },
  main: {},
  footer: {
    email: 'info@newpay.kz',
    firmInfo:
      'ТОО "Нью Пей" БИН 221040018026. ТОО «Нью Пей» с учетной регистрацией в качестве платежной организации, присвоен ' +
      'регистрационный номер № 02-22-142 и записан в Реестр платежных организаций.' +
      '© 2024 ® Newpay. Все права защищены."'
  }
});

export const getOneCreditContentData = (): {
  header: { icon: any; title?: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'OneCredit',
    icon: logoOneCredit
  },
  main: {}
});

export const getCredit365ContentData = (): {
  header: { icon: any; title?: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'Credit365',
    icon: credit365Logo
  },
  main: {}
});

export const getCreditplusContentData = (): {
  header: { icon: any; title?: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'CreditPlus',
    icon: creditplusLogo
  },
  main: {}
});

export const getBeeCreditContentData = (): {
  header: { icon: any; title?: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'BeeCredit',
    icon: beecreditLogo
  },
  main: {}
});

export const getTengebaiContentData = (): {
  header: { icon: any; title?: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'Tengebai',
    icon: logoTengebai
  },
  main: {}
});

export const getFindomContentData = (): {
  header: { icon: any; title?: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'Findom',
    icon: customLogo
  },
  main: {}
});

export const getInstallmentContentData = (): {
  header: { icon: any; title: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'Installment',
    icon: logoInstallment
  },
  main: {}
});

export const getAutomoneyContentData = (): {
  header: { icon: any; title: string };
  main: Record<string, never>;
} => ({
  header: {
    title: 'Automoney',
    icon: customLogo
  },
  main: {}
});
